<template>
  <div class="c-setting">
    <div v-if="!leTbS" class="c-title">
      <span
        ><c-svg t="setting"></c-svg>
        <p class="c-community-name">{{ selectedCommunityName }}</p>
        - {{ $T('page.community.setting.title') }}</span
      >
    </div>

    <template v-for="(setting_group, index) in setting_groups">
      <div class="c-subtitle" :class="{ 'c-danger': setting_group.danger }">{{ setting_group.title }}</div>
      <div class="c-rows" :class="{ 'c-danger': setting_group.danger }">
        <setting-row
          v-for="setting in setting_group.settings"
          :ref="'setting-row-' + setting.id"
          :key="setting.id"
          :settingIndex="index"
          :settingKey="setting.id"
          :setting="setting"
          @click-button="onClickButton"
          @change-value="onChangeParam"
          @change-cover="onChangeCover"
        />
      </div>
    </template>

    <single-input-dialog
      v-if="dialog.target != null"
      ref="single-input-dialog"
      :open="dialog.open"
      :dialogKey="dialog.target.id"
      :dialogType="dialog.target.dialogType"
      :dialogTitle="dialog.target.dialogTitle"
      :fieldName="dialog.target.id"
      :inputLabel="dialog.target.inputLabel"
      :initValue="dialog.target.value"
      :items="dialog.target.items"
      :itemText="dialog.target.itemText"
      :itemValue="dialog.target.itemValue"
      :veeValidate="dialog.target.veeValidate"
      :required="dialog.target.required"
      :counter="dialog.target.counter"
      :apiErrors="apiErrors"
      :onSending="sending"
      @close="onCloseDialog"
      @save="onChangeParam"
    />

    <select-genre-dialog
      v-if="getSetting('genre') && getSetting('genre').value"
      ref="select_genre_dialog"
      :initValue="getSetting('genre').value"
      @save="onChangeParam"
    />

    <select-rule-subscription-dialog
      v-if="getSetting('rule_subscription')"
      ref="select_rule_subscription_dialog"
      :initValue="getSetting('rule_subscription').value"
      @save="onChangeParam"
    />

    <confirm-dialog
      v-if="confirmDialog != null"
      ref="confirm-dialog"
      :open="confirmDialog != null"
      :dialogKey="confirmDialog.id"
      :dialogTitle="confirmDialog.title"
      :dialogText="confirmDialog.text"
      :confirmValue="confirmDialog.confirmValue"
      :errMsg="confirmDialog.errMsg"
      @ok="onConfirmOk"
      @cancel="onCloseDialog"
    />

    <msg-dialog ref="msg_dialog" />

    <select-member-single-dialog ref="select_member_single_dialog" @save="unsubscribeWithMember" />
  </div>
</template>

<script>
import UTILS from '../../utils/utils';
import settingRow from '../common/SettingRow.vue';
import singleInputDialog from '../common/SingleInputDialog.vue';
import selectGenreDialog from '../common/SelectGenreDialog.vue';
import selectRuleSubscriptionDialog from '../common/SelectRuleSubscriptionDialog.vue';
import confirmDialog from '../common/ConfirmDialog.vue';
import selectMemberSingleDialog from '../common/SelectMemberSingleDialog.vue';
import {
  getCommunitySetting,
  updateCommunitySetting,
  updateCommunityCover,
  unsubscribe,
  dissolution,
} from '../../api/community';
import { updateCover } from '../../api/member';
import { updateCommunityMemberCover } from '../../api/communityMember';
import selectCover from '../common/SelectCover.vue';

export default {
  beforeRouteEnter(route, redirect, next) {
    console.log('beforeRouteEnter');
    UTILS.startLoading();
    getCommunitySetting(route.params.id)
      .then(function(response) {
        UTILS.stopLoading();
        next(vm => vm.setSetting(response));
      })
      .catch(function(error) {
        UTILS.stopLoading();
        console.error('failed to get member data', error);
        next(error);
      });
  },
  beforeRouteUpdate(to, from, next) {
    console.log('beforeRouteUpdate');
    UTILS.startLoading();
    var self = this;
    getCommunitySetting(to.params.id)
      .then(function(response) {
        UTILS.stopLoading();
        self.setSetting(response);
        next();
      })
      .catch(function(error) {
        UTILS.stopLoading();
        console.error('failed to get member data', error);
        next(error);
      });
  },
  methods: {
    setSetting(loadedSetting) {
      this.onCloseDialog();
      if (this.$refs.select_genre_dialog) this.$refs.select_genre_dialog.close();
      if (this.$refs.select_rule_subscription_dialog) this.$refs.select_rule_subscription_dialog.close();
      if (this.$refs.community_list_dialog) this.$refs.community_list_dialog.close();
      if (this.$refs.msg_dialog) this.$refs.msg_dialog.close();

      var c = this.$store.state.community.selectedCommunity;

      var values = c.id == 0 ? this.all_values : c.f ? this.friend_values : this.other_values;
      var fields = [
        'profile_name',
        'profile_cover',
        'community_name',
        'community_cover',
        'community_explain',
        'community_mcount',
        'community_volume',
        'genre',
        // 'alert_mail',
        // 'alert_push',
        // 'on_todo',
        // 'on_talk_group',
        // 'on_talk_message',
        // 'on_picture',
        // 'on_event',
        // 'on_add_member',
        'publicity_community',
        'publicity_member',
        'rule_subscription',
        'rule_invitation',
        'rule_admin_accept',
        'unsubscribe',
        'dissolution',
      ];
      // "All Communities" (cid=0) and the friend community have no stored name; the backend resolves
      // it from the API request locale, which can differ from the SPA display language. Show the
      // localized label from the dictionary so the name always matches the displayed language.
      if (c.id == 0) {
        loadedSetting.community_name = $T('community.all');
      } else if (c.f) {
        loadedSetting.community_name = $T('community.friend');
      }
      this.resetAll(fields, values, loadedSetting);

      if (c.f) {
      } else if (this.$store.state.community.selectedCommunity.id != 0) {
        if (loadedSetting.publicity_community == 1) {
          this.getSetting('rule_invitation').items[2].disabled = true;
          this.setParam(
            'rule_invitation',
            'supplement',
            $T('page.community.setting.rule_invitation.supplement.can_not_set', {
              target: $T('page.community.setting.rule_invitation.free'),
            })
          );
          this.setParam('rule_subscription', 'disabled', true);
          this.setParam(
            'rule_subscription',
            'supplement',
            $T('page.community.setting.rule_invitation.supplement.can_not_set', {
              target: $T('attributes.rule_subscription'),
            })
          );
        }
        if (loadedSetting.role != 1 && loadedSetting.role != 2) {
          this.setDisabledByAuth('community_name');
          this.setDisabledByAuth('community_cover');
          this.setDisabledByAuth('community_explain');
          this.setDisabledByAuth('genre');
          this.setDisabledByAuth('rule_subscription');
          this.setDisabledByAuth('rule_invitation');
          this.setDisabledByAuth('rule_admin_accept');
        }
        if (loadedSetting.role != 1) {
          this.setDisabledByAuth('dissolution');
        }
        if (loadedSetting.memberCount <= 1) {
          this.setParam('unsubscribe', 'disabled', true);
          this.setParam('unsubscribe', 'supplement', $T('page.community.setting.unsubscribe.supplement.only_one'));
        }
      }
      if (this.isGuest) {
        var safeFields = ['community_mcount', 'community_volume'];
        for (var i = 0; i < fields.length; i++) {
          if (safeFields.indexOf(fields[i]) != -1) continue;
          this.setParam(fields[i], 'disabled', true);
        }
      }
    },
    resetAll(keys, values, loadedSetting) {
      for (var i = 0, n = keys.length; i < n; i++) {
        var key = keys[i];
        var s = this.getSetting(key);
        s.hideValue = false;
        var setting = Object.assign(s, values[key]);
        setting.value = loadedSetting[key];
        this.$refs['setting-row-' + key][0].resetValue();
      }
      this.getSetting('rule_invitation').items[2].disabled = false;
    },
    setDisabledByAuth(id) {
      this.setParam(id, 'disabled', true);
      this.setParam(id, 'supplement', $T('page.community.setting.common.supplement.only.manager'));
    },
    setParam(key, param, value) {
      var setting = this.getSetting(key);
      if (setting == null)
        return console.error('failed to update param : ' + JSON.stringify({ key: key, param: param, value: value }));
      setting[param] = value;
    },
    getSetting(key) {
      if (this.setting_map == null) {
        var targetTemplate = this.setting_groups;

        // create new map
        var map = {};
        for (var groupIdx in targetTemplate) {
          for (var settingIdx in targetTemplate[groupIdx].settings) {
            var setting = targetTemplate[groupIdx].settings[settingIdx];
            if (map[setting.id] != null) {
              console.error(setting.id + ' is duplicated!');
              continue;
            }
            map[setting.id] = setting;
          }
        }
        this.setting_map = map;
      }
      var setting = this.setting_map[key];
      if (setting == null) {
        console.error(key + ' is not exist!');
      }
      return setting;
    },
    setValue(key, value) {
      this.$refs['setting-row-' + key][0].setValue(value);
      this.setParam(key, 'value', value);
    },
    setDisabled(key, value) {
      this.$refs['setting-row-' + key][0].setDisabled(value);
      this.setParam(key, 'disabled', value);
    },
    setSupplement(key, value) {
      this.$refs['setting-row-' + key][0].setSupplement(value);
      this.setParam(key, 'supplement', value);
    },
    onChangeParam(settingKey, newParam, oldParam) {
      var setting = this.getSetting(settingKey);

      if (setting.id == 'unsubscribe' || setting.id == 'dissolution') {
        var communityName = this.getSetting('community_name').value;
        if (newParam == communityName) {
          var dialog = {};
          dialog.id = setting.id;
          if (setting.id == 'unsubscribe') {
            dialog.title = $T('page.community.setting.unsubscribe.confirm.title');
            dialog.text = $T('page.community.setting.unsubscribe.confirm.text', { community: communityName });
          } else {
            dialog.title = $T('page.community.setting.dissolution.confirm.title');
            dialog.text = $T('page.community.setting.dissolution.confirm.text', { community: communityName });
          }
          dialog.confirmValue = newParam;
          dialog.open = true;
          this.confirmDialog = dialog;
        } else {
          console.log('not match with community name!');
          this.$refs['single-input-dialog'].addError(setting.id, newParam, $T('validation.confirm_community_name'));
        }
      } else if (setting.id == 'profile_cover' || setting.id == 'community_cover') {
        // do nothing
      } else {
        let data = {
          cid: this.selectedCommunity.id,
          id: setting.id,
          value: newParam,
        };

        if (setting.dialogType == 'select' || setting.dialogType == 'text' || setting.dialogType == 'textarea') {
          var self = this;
          this.updateCommunitySetting(
            data,
            component => {
              if (setting.id == 'community_name') {
                self.$store.commit('CHANGE_COMMUNITY_NAME', {
                  id: self.$store.state.community.selectedCommunity.id,
                  name: newParam,
                });
              }
              component.onCloseDialog();
            },
            (component, err) => {
              component.$refs['single-input-dialog'].reValidate();
            }
          );
        } else {
          this.updateCommunitySetting(
            data,
            component => {
              this.setValue(settingKey, newParam);
              if (settingKey == 'genre') {
                this.$refs.select_genre_dialog.close();
              } else if (settingKey == 'rule_subscription') {
                this.$refs.select_rule_subscription_dialog.close();
              }
            },
            (component, err) => {
              this.$refs['setting-row-' + settingKey][0].resetValue();
            }
          );
        }
      }
    },
    onClickButton(settingKey) {
      var setting = this.getSetting(settingKey);
      if (setting.dialogType == 'text' || setting.dialogType == 'select' || setting.dialogType == 'textarea') {
        this.dialog.target = setting;
        this.dialog.open = true;
      } else if (setting.dialogType == 'original') {
        if (setting.id == 'genre') {
          this.$refs.select_genre_dialog.openDialog();
        } else if (setting.id == 'rule_subscription') {
          this.$refs.select_rule_subscription_dialog.openDialog();
        } else {
          this.originalDialog = setting.id;
        }
      } else {
        console.error('Unknown dialogType [' + setting.dialogType + ']');
      }
    },
    onCloseDialog(settingKey) {
      this.dialog.open = false;
      this.dialog.target = null;
      this.apiErrors = {};
      this.originalDialog = null;
      this.sending = false;
      this.onCloseConfirmDialog();
    },
    onConfirmOk(settingKey, confirmValue) {
      var self = this;
      if (settingKey == 'unsubscribe') {
        this.unsubscribeWithMember(settingKey, this.selectedCommunity.id, null);
        return;
      }
      if (settingKey == 'dissolution') {
        let data = {
          cid: this.selectedCommunity.id,
        };
        dissolution(data)
          .then(function(response) {
            self.$store.commit('REMOVE_COMMUNITY', data.cid);
            self.shortMsg($T('page.community.setting.dissolution.complete'));
            return self.$router.push('/community/0/setting/');
          })
          .catch(function(error) {
            console.error(error);
          });
        return;
      }
      console.error('unknown key ' + settingKey);
    },
    onCloseConfirmDialog(settingKey) {
      this.apiErrors = {};
      this.confirmDialog = null;
      this.sending = false;
    },
    onConfirmCancel(settingKey, confirmValue) {
      this.$refs['setting-row-' + settingKey][0].resetValue();
      this.onCloseConfirmDialog(settingKey);
    },
    updateCommunitySetting(data, successCallback, errorCallback) {
      this.sending = true;
      var self = this;
      updateCommunitySetting(data)
        .then(function(response) {
          self.sending = false;
          self.setValue(data.id, data.value);
          if (successCallback) {
            successCallback(self);
          }
        })
        .catch(function(error) {
          console.warn(error);

          var setting = self.getSetting(data.id);
          console.log('set setting api errors');
          if (!self.apiErrors[setting.id]) {
            self.apiErrors[setting.id] = {};
          }

          if (error.errors && (error.errors.id || error.errors.value)) {
            self.apiErrors[setting.id][data.value] = error.errors.id ? error.errors.id[0] : error.errors.value[0];
          } else {
            self.apiErrors[setting.id][data.value] = self.$T('error.unknown');
          }
          self.sending = false;
          if (errorCallback) {
            errorCallback(self, error);
          }
        });
    },
    onChangeCover(settingKey, selectCoverVue) {
      UTILS.startLoading();
      var data = new FormData();
      var cid = this.$store.state.community.selectedCommunity.id;
      data.append('cid', cid);
      data.append('selectedPath', selectCoverVue.path);
      selectCoverVue.appendDeletedCoversToForm(data, 'deletedPathes');
      selectCoverVue.appendNewCoversToForm(data, 'files');
      var self = this;
      if (settingKey == 'profile_cover') {
        if (selectCoverVue.hasDeletedCovers()) {
          this.clearSelfImgCaches();
        } else {
          this.clearSelfImgCach(cid);
        }
        if (cid == 0) {
          updateCover(data)
            .then(function(response) {
              UTILS.stopLoading();
              var path = response.cover_path;
              self.setValue('profile_cover', path);
              self.$store.commit('SET_COVER', path);
              self.originalDialog = null;
              selectCoverVue.resetPath(path);
            })
            .catch(function(error) {
              UTILS.stopLoading();
              console.error('failed to update cover data', error);
            });
        } else {
          updateCommunityMemberCover(data)
            .then(function(response) {
              UTILS.stopLoading();
              var path = response.cover_path;
              self.setValue('profile_cover', path);
              self.$store.commit('COM_UPDATE_PROFILE', { cid: cid, path: path });
              self.originalDialog = null;
              selectCoverVue.resetPath(path);
            })
            .catch(function(error) {
              UTILS.stopLoading();
              console.error('failed to update cover data', error);
            });
        }
      } else {
        updateCommunityCover(data)
          .then(function(response) {
            UTILS.stopLoading();
            var path = response.cover_path;
            self.setValue('community_cover', path);
            self.$store.commit('CHANGE_COMMUNITY_COVER', {
              id: cid,
              path: path,
            });
            self.originalDialog = null;
            selectCoverVue.resetPath(path);
          })
          .catch(function(error) {
            UTILS.stopLoading();
            console.error('failed to update cover data', error);
          });
      }
    },
    unsubscribeWithMember(settingKey, altCommunityMemberId) {
      var self = this;
      let data;
      if (altCommunityMemberId) {
        data = {
          cid: this.selectedCommunity.id,
          altAdminId: altCommunityMemberId,
        };
      } else {
        data = {
          cid: this.selectedCommunity.id,
        };
      }
      unsubscribe(data)
        .then(function(response) {
          if (response.require == 'none') {
            self.$store.commit('REMOVE_COMMUNITY', data.cid);
            self.shortMsg($T('page.community.setting.unsubscribe.complete'));
            self.$refs.select_member_single_dialog.closeDialog();
            return self.$router.push('/community/0/setting/');
          }
          if (response.require == 'alt') {
            self.$refs.select_member_single_dialog.openDialog(
              settingKey,
              $T('page.community.setting.unsubscribe.change.owner.title'),
              $T('page.community.setting.unsubscribe.change.owner.text'),
              $T('attributes.new_super_user'),
              response.altMembers,
              altCommunityMemberId
            );
            return self.onCloseDialog(settingKey);
          }
          if (response.require == 'dissolution') {
            self.$refs.msg_dialog.open(
              $T('page.community.setting.unsubscribe.dissolution.title'),
              $T('page.community.setting.unsubscribe.dissolution.text')
            );
            return self.onCloseDialog(settingKey);
          }
          log.error('unknown response type [' + response.require + ']');
        })
        .catch(function(error) {
          console.error(error);
        });
    },
  },
  components: {
    'setting-row': settingRow,
    'single-input-dialog': singleInputDialog,
    'select-genre-dialog': selectGenreDialog,
    'select-rule-subscription-dialog': selectRuleSubscriptionDialog,
    'select-member-single-dialog': selectMemberSingleDialog,
    'confirm-dialog': confirmDialog,
  },
  data() {
    return {
      dialog: {
        open: false,
        target: null,
      },
      confirmDialog: null,
      originalDialog: null,
      coverImgs: null,
      apiErrors: {},
      sending: false,
      loaded_settings: null,
      setting_map: null,
      all_values: {
        community_name: { disabled: true, supplement: $T('page.community.setting.common.supplement.invalid.all') },
        community_cover: { disabled: false, supplement: '' },
        community_explain: { disabled: true, supplement: $T('page.community.setting.common.supplement.invalid.all') },
        community_mcount: { disabled: true, explain: $T('page.community.setting.community.mcount.explain') },
        community_volume: { disabled: true, explain: $T('page.community.setting.community.volume.explain') },
        genre: {
          disabled: true,
          supplement: $T('page.community.setting.common.supplement.invalid.all'),
          hideValue: true,
        },
        profile_name: { disabled: false, supplement: $T('page.community.setting.profile.supplement.all') },
        profile_cover: { disabled: false, supplement: $T('page.community.setting.profile_cover.supplement.all') },
        // alert_mail : { disabled: false, supplement: $T('page.community.setting.common.supplement.common.all'), },
        // alert_push : { disabled: false, supplement: $T('page.community.setting.common.supplement.common.all'), },
        // on_todo : { disabled: false, supplement: $T('page.community.setting.common.supplement.common.all'), },
        // on_talk_group : { disabled: false, supplement: $T('page.community.setting.common.supplement.common.all'), },
        // on_talk_message : { disabled: false, supplement: $T('page.community.setting.common.supplement.common.all'), },
        // on_picture : { disabled: false, supplement: $T('page.community.setting.common.supplement.common.all'), },
        // on_event : { disabled: false, supplement: $T('page.community.setting.common.supplement.common.all'), },
        // on_add_member : { disabled: false, supplement: $T('page.community.setting.common.supplement.common.all'), },
        publicity_community: {
          disabled: true,
          supplement: $T('page.community.setting.common.supplement.invalid.all'),
          hideValue: true,
        },
        publicity_member: {
          disabled: true,
          supplement: $T('page.community.setting.common.supplement.invalid.all'),
          hideValue: true,
        },
        rule_subscription: {
          disabled: true,
          supplement: $T('page.community.setting.common.supplement.invalid.all'),
          hideValue: true,
        },
        rule_invitation: {
          disabled: true,
          supplement: $T('page.community.setting.common.supplement.invalid.all'),
          hideValue: true,
        },
        rule_admin_accept: {
          disabled: true,
          supplement: $T('page.community.setting.common.supplement.invalid.all'),
          hideValue: true,
        },
        unsubscribe: { disabled: true, supplement: $T('page.community.setting.common.supplement.invalid.all') },
        dissolution: { disabled: true, supplement: $T('page.community.setting.common.supplement.invalid.all') },
      },
      friend_values: {
        community_name: { disabled: true, supplement: $T('page.community.setting.common.supplement.invalid.friends') },
        community_cover: { disabled: false, supplement: '' },
        community_explain: {
          disabled: true,
          supplement: $T('page.community.setting.common.supplement.invalid.friends'),
        },
        community_mcount: { disabled: false, explain: $T('page.community.setting.community.mcount.friend') },
        community_volume: { disabled: false, explain: $T('page.community.setting.community.volume.friend') },
        genre: {
          disabled: true,
          supplement: $T('page.community.setting.common.supplement.invalid.friends'),
          hideValue: true,
        },
        profile_name: { disabled: false, supplement: '' },
        profile_cover: { disabled: false, supplement: '' },
        // alert_mail : { disabled: false, supplement: $T('page.community.setting.common.supplement.common.all'), },
        // alert_push : { disabled: false, supplement: $T('page.community.setting.common.supplement.common.all'), },
        // on_todo : { disabled: false, supplement: $T('page.community.setting.common.supplement.common.all'), },
        // on_talk_group : { disabled: false, supplement: $T('page.community.setting.common.supplement.common.all'), },
        // on_talk_message : { disabled: false, supplement: $T('page.community.setting.common.supplement.common.all'), },
        // on_picture : { disabled: false, supplement: $T('page.community.setting.common.supplement.common.all'), },
        // on_event : { disabled: false, supplement: $T('page.community.setting.common.supplement.common.all'), },
        // on_add_member : { disabled: false, supplement: $T('page.community.setting.common.supplement.common.all'), },
        publicity_community: {
          disabled: true,
          supplement: $T('page.community.setting.common.supplement.invalid.friends'),
          hideValue: true,
        },
        publicity_member: {
          disabled: true,
          supplement: $T('page.community.setting.common.supplement.invalid.friends'),
          hideValue: true,
        },
        rule_subscription: {
          disabled: true,
          supplement: $T('page.community.setting.common.supplement.invalid.friends'),
          hideValue: true,
        },
        rule_invitation: {
          disabled: true,
          supplement: $T('page.community.setting.common.supplement.invalid.friends'),
          hideValue: true,
        },
        rule_admin_accept: {
          disabled: true,
          supplement: $T('page.community.setting.common.supplement.invalid.friends'),
          hideValue: true,
        },
        unsubscribe: { disabled: true, supplement: $T('page.community.setting.common.supplement.invalid.friends') },
        dissolution: { disabled: true, supplement: $T('page.community.setting.common.supplement.invalid.friends') },
      },
      other_values: {
        community_name: { disabled: false, supplement: '' },
        community_cover: { disabled: false, supplement: $T('page.community.setting.community.cover.supplement.other') },
        community_explain: {
          disabled: false,
          supplement: $T('page.community.setting.community.explain.supplement.other'),
        },
        community_mcount: { disabled: false, explain: $T('page.community.setting.community.mcount.explain') },
        community_volume: { disabled: false, explain: $T('page.community.setting.community.volume.explain') },
        genre: { disabled: false, supplement: '' },
        profile_name: { disabled: false, supplement: '' },
        profile_cover: { disabled: false, supplement: '' },
        // alert_mail : { disabled: false, supplement: '', },
        // alert_push : { disabled: false, supplement: '', },
        // on_todo : { disabled: false, supplement: '', },
        // on_talk_group : { disabled: false, supplement: '', },
        // on_talk_message : { disabled: false, supplement: '', },
        // on_picture : { disabled: false, supplement: '', },
        // on_event : { disabled: false, supplement: '', },
        // on_add_member : { disabled: false, supplement: '', },
        publicity_community: {
          disabled: true,
          supplement: $T('page.community.setting.common.supplement.invalid.privacy'),
        },
        publicity_member: {
          disabled: true,
          supplement: $T('page.community.setting.common.supplement.invalid.privacy'),
        },
        rule_subscription: { disabled: false, supplement: '' },
        rule_invitation: { disabled: false, supplement: '' },
        rule_admin_accept: { disabled: false, supplement: '' },
        unsubscribe: { disabled: false, supplement: '' },
        dissolution: { disabled: false, supplement: '' },
      },
      setting_groups: [
        {
          title: $T('page.community.setting.sub_title.community'),
          settings: [
            {
              id: 'community_name',
              type: 'value-button',
              title: $T('attributes.community_name'),
              explain: $T('page.community.setting.community.name.explain'),
              disabled: false,
              dialogType: 'text',
              dialogTitle: $T('common.change_attribute', { attr: $T('attributes.community_name') }),
              inputLabel: $T('attributes.community_name'),
              veeValidate: 'max:100',
              required: true,
              counter: 100,
              supplement: '',
              disabled: false,
              value: '',
              hideValue: false,
            },
            {
              id: 'community_cover',
              type: 'cover',
              title: $T('attributes.community_cover'),
              explain: $T('page.community.setting.community.cover.explain'),
              disabled: false,
              dialogType: 'original',
              supplement: '',
              disabled: false,
              value: '',
              hideValue: false,
            },
            {
              id: 'community_explain',
              type: 'button',
              title: $T('attributes.community_explain'),
              explain: $T('page.community.setting.community.explain.explain'),
              btnname: $T('button.modify'),
              disabled: false,
              dialogType: 'textarea',
              dialogTitle: $T('common.change_attribute', { attr: $T('attributes.community_explain') }),
              inputLabel: $T('attributes.community_explain'),
              veeValidate: 'max:10000',
              required: false,
              counter: 10000,
              supplement: '',
              disabled: false,
              value: '',
              hideValue: false,
            },
            {
              id: 'community_mcount',
              type: 'none',
              title: $T('page.community.setting.community.mcount.title'),
              explain: $T('page.community.setting.community.mcount.explain'),
              disabled: false,
              supplement: '',
              disabled: false,
              editValue: function(component, value) {
                if (!value) return '- / -';
                var r = component.$utils.addComma(value[0]) + ' / ' + component.$utils.addComma(value[1]);
                if (value[0] >= value[1]) return `<span class="clr-danger--text">${r}</span>`;
                return r;
              },
              value: '',
              hideValue: false,
            },
            {
              id: 'community_volume',
              type: 'none',
              title: $T('page.community.setting.community.volume.title'),
              explain: $T('page.community.setting.community.volume.explain'),
              disabled: false,
              supplement: $T('page.community.setting.community.volume.supplement'),
              disabled: false,
              editValue: function(component, value) {
                if (!value) return '- / -';
                var r = component.$utils.toGB(value[0]) + ' / ' + component.$utils.toGB(value[1]);
                if (value[0] >= value[1]) return `<span class="clr-danger--text">${r}</span>`;
                return r;
              },
              value: '',
              hideValue: false,
            },
            {
              id: 'genre',
              type: 'value-button',
              title: $T('attributes.genre'),
              explain: $T('page.community.setting.genre.explain'),
              editValue: function(component, value) {
                return (
                  component.$commin.genres(value.genre).value +
                  '\n - ' +
                  component.$commin.subGenres(value.sub_genre).value
                );
              },
              disabled: false,
              dialogType: 'original',
              supplement: '',
              disabled: false,
              value: {},
              hideValue: false,
            },
          ],
        },
        {
          title: $T('page.community.setting.sub_title.profile'),
          settings: [
            {
              id: 'profile_name',
              type: 'value-button',
              title: $T('attributes.profile'),
              explain: $T('page.community.setting.profile.explain'),
              disabled: false,
              dialogType: 'text',
              dialogTitle: $T('common.change_attribute', { attr: $T('attributes.profile') }),
              inputLabel: $T('attributes.profile'),
              veeValidate: 'max:50',
              required: false,
              counter: 50,
              supplement: '',
              disabled: false,
              value: '',
              hideValue: false,
            },
            {
              id: 'profile_cover',
              type: 'cover',
              title: $T('attributes.profile_cover'),
              explain: $T('page.community.setting.profile_cover.explain'),
              dialogType: 'original',
              supplement: '',
              disabled: false,
              value: '',
              hideValue: false,
            },
          ],
        },
        // {
        //   title : $T('page.community.setting.sub_title.alert'),
        //   settings: [
        //     {
        //       id: "alert_mail",
        //       type: "switch",
        //       title: $T("attributes.alert_mail"),
        //       explain:$T('page.community.setting.alert_mail.explain'),
        //       supplement: '',
        //       disabled: false,
        //       value: '',
        //     },
        //     {
        //       id: "alert_push",
        //       type: "switch",
        //       title: $T("attributes.alert_push"),
        //       explain:$T('page.community.setting.alert_push.explain'),
        //       supplement: '',
        //       disabled: false,
        //       value: '',
        //     },
        //   ],
        // },
        // {
        //   title : $T('page.community.setting.sub_title.alert_when'),
        //   settings: [
        //     {
        //       id: "on_todo",
        //       type: "switch",
        //       title: $T("attributes.on_todo"),
        //       explain:$T('page.community.setting.on_todo.explain'),
        //       supplement: '',
        //       disabled: false,
        //       value: '',
        //     },
        //     {
        //       id: "on_talk_group",
        //       type: "switch",
        //       title: $T("attributes.on_talk_group"),
        //       explain:$T('page.community.setting.on_talk_group.explain'),
        //       supplement: '',
        //       disabled: false,
        //       value: '',
        //     },
        //     {
        //       id: "on_talk_message",
        //       type: "switch",
        //       title: $T("attributes.on_talk_message"),
        //       explain:$T('page.community.setting.on_talk_message.explain'),
        //       supplement: '',
        //       disabled: false,
        //       value: '',
        //     },
        //     {
        //       id: "on_picture",
        //       type: "switch",
        //       title: $T("attributes.on_picture"),
        //       explain:$T('page.community.setting.on_picture.explain'),
        //       supplement: '',
        //       disabled: false,
        //       value: '',
        //     },
        //     {
        //       id: "on_event",
        //       type: "switch",
        //       title: $T("attributes.on_event"),
        //       explain:$T('page.community.setting.on_event.explain'),
        //       supplement: '',
        //       disabled: false,
        //       value: '',
        //     },
        //     {
        //       id: "on_add_member",
        //       type: "switch",
        //       title: $T("attributes.on_add_member"),
        //       explain:$T('page.community.setting.on_add_member.explain'),
        //       supplement: '',
        //       disabled: false,
        //       value: '',
        //     },
        //   ],
        // },
        {
          title: $T('page.community.setting.sub_title.publishing'),
          settings: [
            {
              id: 'publicity_community',
              type: 'radio',
              title: $T('attributes.publicity_community'),
              explain: $T('page.community.setting.publicity_community.explain'),
              items: [
                { value: 1, label: $T('page.community.setting.publicity_community.private') },
                { value: 2, label: $T('page.community.setting.publicity_community.semi_public') },
                { value: 3, label: $T('page.community.setting.publicity_community.public') },
              ],
              supplement: '',
              disabled: false,
              value: '',
              hideValue: false,
            },
            {
              id: 'publicity_member',
              type: 'switch',
              title: $T('attributes.publicity_member'),
              explain: $T('page.community.setting.publicity_member.explain'),
              supplement: '',
              disabled: false,
              value: '',
              hideValue: false,
            },
          ],
        },
        {
          title: $T('page.community.setting.sub_title.join_rule'),
          settings: [
            {
              id: 'rule_subscription',
              type: 'value-button',
              title: $T('attributes.rule_subscription'),
              explain: $T('page.community.setting.rule_subscription.explain'),
              dialogType: 'original',
              editValue: function(component, value) {
                var result = '';
                if (value) {
                  if (value.min_age > 0 || value.max_age > 0) {
                    result +=
                      $T('attributes.rule_subscription_age') +
                      ' : ' +
                      (Number(value.min_age) > 0 ? value.min_age : '') +
                      ' ~ ' +
                      (Number(value.max_age) > 0 ? value.max_age : '') +
                      '\n';
                  }
                  if (value.gender) {
                    result +=
                      $T('attributes.rule_subscription_gender') +
                      ' : ' +
                      (Number(value.gender) == 1
                        ? $T('params.gender.male')
                        : Number(value.gender) == 2
                        ? $T('params.gender.female')
                        : $T('params.gender.other'));
                  }
                }
                return result == '' ? $T('param.none') : result;
              },
              supplement: '',
              disabled: false,
              value: {},
              hideValue: false,
            },
            {
              id: 'rule_invitation',
              type: 'radio',
              title: $T('attributes.rule_invitation'),
              explain: $T('page.community.setting.rule_invitation.explain'),
              items: [
                { value: 1, label: $T('page.community.setting.rule_invitation.manager') },
                { value: 2, label: $T('page.community.setting.rule_invitation.member') },
                { value: 3, label: $T('page.community.setting.rule_invitation.free') },
              ],
              supplement: '',
              disabled: false,
              value: '',
              hideValue: false,
            },
            {
              id: 'rule_admin_accept',
              type: 'switch',
              title: $T('attributes.rule_admin_accept'),
              explain: $T('page.community.setting.rule_admin_accept.explain'),
              supplement: '',
              disabled: false,
              value: '',
              hideValue: false,
            },
          ],
        },
        {
          title: $T('page.community.setting.sub_title.unsubscribe'),
          danger: true,
          settings: [
            {
              id: 'unsubscribe',
              type: 'button',
              title: $T('attributes.unsubscribe'),
              explain: $T('page.community.setting.unsubscribe.explain'),
              btnname: $T('button.run'),
              dialogType: 'text',
              dialogTitle: $T('page.community.setting.unsubscribe.confirm.input_title'),
              inputLabel: $T('attributes.community_name'),
              veeValidate: '',
              required: true,
              counter: 100,
              supplement: '',
              disabled: false,
              value: '',
              danger: true,
              hideValue: false,
            },
            {
              id: 'dissolution',
              type: 'button',
              title: $T('attributes.dissolution'),
              explain: $T('page.community.setting.dissolution.explain'),
              btnname: $T('button.run'),
              dialogType: 'text',
              dialogTitle: $T('page.community.setting.dissolution.confirm.input_title'),
              inputLabel: $T('attributes.community_name'),
              veeValidate: '',
              required: true,
              counter: 100,
              supplement: '',
              disabled: false,
              value: '',
              danger: true,
              hideValue: false,
            },
          ],
        },
      ],
    };
  },
};
</script>
